import { Throbber } from 'app/components/throbber';
import { useI18n } from 'core/hooks/useI18n';
import { Routing } from 'core/routing/Routing';
import { lazy, Suspense } from 'react';
import { Route } from 'react-router';

const CreateScenario = lazy(() => import('app/views/blasting/pages/create-scenario'));
const CommonFields = lazy(
  () => import('app/views/blasting/pages/create-scenario/components/form-sections/CommonFields')
);
const FlyrockFields = lazy(
  () => import('app/views/blasting/pages/create-scenario/components/form-sections/FlyrockFields')
);
const GroundVibrationFields = lazy(
  () => import('app/views/blasting/pages/create-scenario/components/form-sections/GroundVibrationFields')
);
const OverpressureFields = lazy(
  () => import('app/views/blasting/pages/create-scenario/components/form-sections/OverpressureFields')
);
const PathFields = lazy(() => import('app/views/blasting/pages/create-scenario/components/form-sections/PathFields'));
const PollutantFields = lazy(
  () => import('app/views/blasting/pages/create-scenario/components/form-sections/pollutant-fields/PollutantFields')
);

export function CreateScenarioRoutes() {
  const { l10n } = useI18n('app');
  return (
    <Route
      path={Routing.routes.blasting.createNew.root}
      element={
        <Suspense fallback={<Throbber>{l10n('loading.screen.blasting')}</Throbber>}>
          <CreateScenario />
        </Suspense>
      }
    >
      <Route
        index
        element={
          <Suspense fallback={<Throbber>{l10n('loading.screen.blasting')}</Throbber>}>
            <CommonFields />
          </Suspense>
        }
      />

      <Route
        path={Routing.routes.blasting.createNew['overpressureContour|overpressureGain']}
        element={
          <Suspense fallback={<Throbber>{l10n('loading.screen.blasting')}</Throbber>}>
            <OverpressureFields />
          </Suspense>
        }
      />

      <Route
        path={Routing.routes.blasting.createNew.path}
        element={
          <Suspense fallback={<Throbber>{l10n('loading.screen.blasting')}</Throbber>}>
            <PathFields />
          </Suspense>
        }
      />

      <Route
        path={Routing.routes.blasting.createNew['dispersion|fumeManagementZone']}
        element={
          <Suspense fallback={<Throbber>{l10n('loading.screen.blasting')}</Throbber>}>
            <PollutantFields />
          </Suspense>
        }
      />

      <Route
        path={Routing.routes.blasting.createNew.flyrock}
        element={
          <Suspense fallback={<Throbber>{l10n('loading.screen.blasting')}</Throbber>}>
            <FlyrockFields />
          </Suspense>
        }
      />

      <Route
        path={Routing.routes.blasting.createNew.groundVibration}
        element={
          <Suspense fallback={<Throbber>{l10n('loading.screen.blasting')}</Throbber>}>
            <GroundVibrationFields />
          </Suspense>
        }
      />
    </Route>
  );
}
